exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.chat li {\r\n    margin-bottom: 10px;\r\n    padding-bottom: 5px;\r\n    border-bottom: 1px dotted #B3A9A9;\r\n}\r\n\r\n.chat li.left .chat-body {\r\n    margin-left: 60px;\r\n}\r\n\r\n.chat li.right .chat-body {\r\n    margin-right: 60px;\r\n}\r\n\r\n.chat .chat-img {\r\n    width: 50px;\r\n    height: 50px;\r\n    padding: 15px 17px;\r\n    border-radius: 50% !important;\r\n    color: white;\r\n}\r\n\r\n.chat .right .chat-img {\r\n    background: #fa6f57;\r\n}\r\n.chat .left .chat-img {\r\n    background: #AEEEEE;\r\n}\r\n\r\n.chat li .chat-body p {\r\n    margin: 0;\r\n    color: #777777;\r\n}\r\n\r\n.chat li.left .header small{\r\n    float: right;\r\n}\r\n\r\n.chat li.right .header strong{\r\n    float: right;\r\n}\r\n\r\ntextarea{\r\n    max-width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/quick-action-messages.component.css
// module id = 994
// module chunks = 1